import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'
import { RouteErrorBoundary } from '@/components/routing/RouteErrorBoundary'
import { LoginPage } from '@/pages/auth'
import { suspensePage } from '@/routes/suspensePage'

const SignupPage = lazy(() => import('@/pages/auth/SignupPage'))
const ForgotPasswordPage = lazy(() => import('@/pages/auth/ForgotPasswordPage'))
const ResetPasswordPage = lazy(() => import('@/pages/auth/ResetPasswordPage'))
const PrivacyPolicyPage = lazy(() => import('@/pages/PrivacyPolicyPage'))

/** Top-level routes reachable without the app shell (no Layout, no auth). */
export const publicRoutes: RouteObject[] = [
  { path: '/login', element: <LoginPage />, errorElement: <RouteErrorBoundary /> },
  { path: '/signup', element: suspensePage(SignupPage), errorElement: <RouteErrorBoundary /> },
  { path: '/forgot-password', element: suspensePage(ForgotPasswordPage), errorElement: <RouteErrorBoundary /> },
  { path: '/reset-password', element: suspensePage(ResetPasswordPage), errorElement: <RouteErrorBoundary /> },
  { path: '/privacy', element: suspensePage(PrivacyPolicyPage), errorElement: <RouteErrorBoundary /> },
]
